import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, TrendingUp, Clock, Target } from 'lucide-react';

const TrustBar = () => {
  const stats = [
    { icon: CheckCircle2, value: '98%', label: 'Clean Claims Rate', color: '#14b8a6' },
    { icon: Target, value: '95%+', label: 'First-Pass Acceptance', color: '#1e3a8a' },
    { icon: TrendingUp, value: '5-10%', label: 'Revenue Increase', color: '#14b8a6' },
    { icon: Clock, value: '48hr', label: 'Claim Turnaround', color: '#1e3a8a' },
  ];

  return (
    <section className="py-16 bg-white border-y border-slate-100">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-100px' }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                whileHover={{ y: -5 }}
                className="text-center group cursor-pointer"
              >
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ duration: 0.3 }}
                  className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 transition-all duration-300"
                  style={{
                    backgroundColor: `${stat.color}15`,
                  }}
                >
                  <Icon size={32} style={{ color: stat.color }} />
                </motion.div>
                <motion.div
                  className="text-4xl font-bold mb-2"
                  style={{ color: stat.color }}
                  whileHover={{ scale: 1.05 }}
                >
                  {stat.value}
                </motion.div>
                <div className="text-slate-600 font-medium">{stat.label}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
